const imageUrl = url => `url( '${url}' )`;
const pct = (amt, of) => `${amt / of}%`;
const oneOf = arrayOfStrings => string => arrayOfStrings.indexOf(string) !== -1;

import './TestHeader.scss';
import template from './TestHeader.vhtml';

export default {
	name: 'TestHeader',
	template: template,
	props: {
		introduction: {
			type: String,
		},
		situation: {
			type: Object,
			required: true,
		},
		housing: {
			type: Object,
			required: true,
		},
		interests: {
			type: Array,
			required: true,
		},
		options: {
			type: Object,
			required: true,
		},
		buttonType: {
			type: String,
			default: 'none',
			validator: oneOf(['none', 'close', 'link']),
		},
	},
	methods: {
		close() {
			this.$emit('close');
		},
		imageUrl: url => `url( '${url}' )`,
		pct: (amt, of) => `${amt / of * 100}%`,
	},
	computed: {
		images() {
			const availableImages = this.interests
				.map(interest => ([interest.top_image_1, interest.top_image_2, interest.top_image_3]))
				.reduce((acc, val) => acc.concat(val), [])
				.filter(val => val !== false);
			return randomArray(3, availableImages);
		},
	}
};

const randomIntFromInterval = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

function randomArray(amt, array) {
	if (amt === 0 || array.length === 0) {
		return [];
	}
	const index = randomIntFromInterval(0, array.length - 1);
	return [array[index]].concat(randomArray(amt - 1, array.filter((val, i) => i !== index)));
}
